// extracted by mini-css-extract-plugin
module.exports = {"winnerItem":"_146a814","reversed":"_eb0839a","details":"_53e14cd","username":"_1d10dbb","award":"_d27dc50"};